import Controller from "./stationsHeatmap.controller";
import template from "./stationsHeatmap.html";

const stationsHeatmap = {
  template,
  controller: Controller,
};

export default stationsHeatmap;



// WEBPACK FOOTER //
// ./src/pages/stationsHeatmap/stationsHeatmap.component.js